// Browser-history wiring for the Actuals vs Budget page tabs.
//
// Flowbite tab switches are purely client-side and create no history entries,
// so pressing Back while on e.g. the Reports tab exits the whole page. This
// module pushes a history entry on every primary-tab change and replays the
// tab from the URL on popstate, so Back/Forward walk through tabs instead of
// leaving the section.
//
// Reconciliation is a separate page reached via a real link, so it produces
// its own history entry on navigation and needs no handling here.

const NAV_ID = 'actual-vs-budget-report-tabs';
const DEFAULT_TAB = 'generate_report';

function activeTabFromUrl() {
    const params = new URLSearchParams(window.location.search);
    return params.get('tab') || DEFAULT_TAB;
}

function pushTabState(tabId) {
    const params = new URLSearchParams(window.location.search);
    params.set('tab', tabId);
    const url = window.location.pathname + '?' + params.toString();
    window.history.pushState({ tab: tabId }, '', url);
}

document.addEventListener('DOMContentLoaded', () => {
    const nav = document.getElementById(NAV_ID);
    if (!nav || !window.history?.pushState) {
        return;
    }

    nav.querySelectorAll('[role="tab"]').forEach((triggerEl) => {
        triggerEl.addEventListener('click', () => {
            const tabId = triggerEl.getAttribute('aria-controls');
            if (!tabId || tabId === activeTabFromUrl()) {
                return;
            }
            pushTabState(tabId);
        });
    });

    window.addEventListener('popstate', () => {
        const instance = window.FlowbiteInstances?.getInstance('Tabs', NAV_ID);
        if (instance) {
            instance.show('#' + activeTabFromUrl());
        }
    });
});
